import React, { Component, createRef } from "react";

/**
 * Tiny scroll-reveal wrapper using native IntersectionObserver.
 * Replaces react-awesome-reveal — no library, no animations bug, ~30 lines.
 *
 * Usage:
 *   <Reveal direction="up" delay={200}>
 *     <h3>Hello</h3>
 *   </Reveal>
 *
 * Props:
 *   direction: "up" | "left" | "right" | "fade"   (default "up")
 *   delay:     ms before animation starts          (default 0)
 *   duration:  ms of the animation                 (default 800)
 *   triggerOnce: animate only the first time visible (default true)
 */
class Reveal extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
    this.ref = createRef();
  }

  componentDidMount() {
    if (typeof IntersectionObserver === "undefined") {
      this.setState({ visible: true });
      return;
    }
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ visible: true });
          if (this.props.triggerOnce !== false) this.observer.disconnect();
        } else if (this.props.triggerOnce === false) {
          this.setState({ visible: false });
        }
      },
      { threshold: 0.12 }
    );
    if (this.ref.current) this.observer.observe(this.ref.current);
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  render() {
    const { direction = "up", delay = 0, duration = 800, children, className = "" } = this.props;
    const visibleClass = this.state.visible ? "reveal-visible" : "";
    const style = {
      transitionDuration: `${duration}ms`,
      transitionDelay: `${delay}ms`
    };
    return (
      <div ref={this.ref} className={`reveal reveal-${direction} ${visibleClass} ${className}`.trim()} style={style}>
        {children}
      </div>
    );
  }
}

export default Reveal;
